import { Box, Divider, Typography, useTheme } from "@material-ui/core";
import type { TypographyProps } from "@material-ui/core";
import type { CSSProperties } from "react";

interface DividerWithTextProps {
    text: string;
    textColor?: CSSProperties["color"];
    textPadding?: CSSProperties["padding"];
    margin?: CSSProperties["margin"];
    maxWidth?: CSSProperties["maxWidth"];
    variant?: TypographyProps["variant"];
}

export default function DividerWithText({
    text,
    textColor,
    textPadding = "0 16px",
    margin = "20px 0",
    maxWidth = "100%",
    variant = "body2",
}: DividerWithTextProps) {
    const theme = useTheme();
    return (
        <Box display="flex" alignItems="center" style={{ margin, width: "100%", maxWidth }}>
            <Divider style={{ flex: 1 }} />
            <Typography
                variant={variant}
                style={{ marginBottom: "0px", color: textColor || theme.palette.text.secondary, padding: textPadding }}
            >
                {text}
            </Typography>
            <Divider style={{ flex: 1 }} />
        </Box>
    );
}
